const pxTo = (px, suffix, base) => {
  return `${px / base}${suffix}`;
};
export const pxToRem = (px, base = 16) => {
  return pxTo(px, 'rem', base);
};
export const pxToEm = (px, base = 16) => {
  return pxTo(px, 'em', base);
};
export function dictionaryToArray(dict) {
  return Object.keys(dict).map(key => dict[key]);
}
// Used to convert style object to css for typographic elements like h1...h6
export const getTypographyStyle = (theme, key, includeKey = true) => {
  return `
    ${includeKey ? `${key} {` : ''}
      color: ${theme.typography[key].color};
      font-family: ${theme.typography[key].fontFamily};
      font-weight:  ${theme.typography[key].fontWeight};
      font-size:  ${theme.typography[key].fontSize};
      line-height:  ${theme.typography[key].lineHeight};
      margin:  ${theme.typography[key].margin};
    ${includeKey ? '}' : ''}
  `;
};